import Filters from './Filters';
import Results from './Results';

let Mobile = () => {
    return (
        <>
            <Filters />
            <Results />
        </>
    )
}

export default Mobile;